import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const findUser = createAsyncThunk(
  "userShow/findUser",
  async (id: number, { rejectWithValue }) => {
    try {
      const url = new URL(`${api.baseURL}user/${id}`);
      const token = localStorage.getItem("token");
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      headers.append("Content-Type", "application/json");

      let response = await fetch(url.toJSON(), {
        method: "GET",
        headers: headers,
      });
      if (!response.ok) {
        throw response.statusText;
      }
      let data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
